module.exports = __webpack_public_path__ + "img/test.9a948991.svg";